import RoleAssignmentComponent from '../Components/RoleAssignmentComponent';

function RoleAssignmentPage() {
  return <RoleAssignmentComponent />;
}

export default RoleAssignmentPage;
